<template>
  <section class="grid-block">
    <header>
      <span>Заявки</span>
      <VButton
        theme="link"
        :disabled="demandV2.isOptionsSelected"
        @click="createRequest"
      >
        Добавить заявку +
      </VButton>
    </header>

    <div
      v-if="isRequestsMoreThen1"
      class="content"
    >
      <VDataGridV2
        :data="demandV2.requests"
        :context-menu="DemandsV2Service.demandRequestContextMenu"
        layout="fill"
        @row:dblclick="editRequest"
        @contextMenuItem:done="onContextMenuItemDone"
      >
        <VDataGridColumnV2
          id="desiredReceiptDate"
          label="Дата доставки"
          width="150px"
        >
          <template #default="{ row }">
            {{ row.desiredReceiptDate?.format() }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="qty"
          label="Количество"
          width="120px"
        >
          <template #default="{ row }">
            {{ row.qtyDesired?.format(demandV2.unit) }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          v-if="hasChosenOptions"
          id="sum"
          label="Сумма"
          width="150px"
        >
          <template #default="{ row }">
            {{ row.sumFullSeller?.format(demandV2.currencyCode) || '--' }}
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>

      <footer>
        <b>Итого:</b> {{ qtyDesiredTotal.format(demandV2.unit) }}
      </footer>
    </div>

    <template v-else>
      <DemandRequestCreateForm :request="singleRequest" />

      <span>
        Сумма: {{ sumFullSeller?.format(demandV2.currencyCode) || '--' }}
      </span>
    </template>
  </section>
</template>

<script lang="ts">

import DemandV2                from '@/domains/DemandsV2/DemandV2';
import DemandRequest           from '@/domains/DemandsV2/DemandRequest';
import DemandsV2Service        from '@/domains/DemandsV2/DemandsV2Service';
import Sum                     from "@/core/types/Sum";
import Qty                     from "@/core/types/Qty";

import DemandRequestCreateForm from '@/domains/DemandsV2/components/DemandV2Card/DemandV2RequestDialog/DemandRequestCreateForm.vue';

export default defineComponent({
  name: 'DemandV2RequestsOptionSection',

  components: {
    DemandRequestCreateForm,
  },

  props: {
    demandV2: {
      type:     DemandV2,
      required: true,
    },
  },

  /** Заявки изменились — потребность нужно перечитать */
  emits: ['change'],

  setup() {
    return {
      DemandsV2Service,
    };
  },

  computed: {
    hasChosenOptions(): boolean {
      return this.$core.utils.isNotEmptyArray(this.demandV2.chosenOptions);
    },

    isRequestsMoreThen1(): boolean {
      return this.demandV2.requests.length > 1;
    },

    singleRequest(): DemandRequest | null {
      if (this.isRequestsMoreThen1) {
        return null;
      }
      return this.demandV2.requests[0];
    },

    sumFullSeller(): Sum | null {
      if (this.isRequestsMoreThen1) {
        return null;
      }
      return this.singleRequest?.sumFullSeller ?? null;
    },

    /** Итого желаемого количества по всем заявкам. */
    qtyDesiredTotal(): Qty {
      let result = Qty.zero();

      this.demandV2.requests.forEach((request) => {
        result = result.plus(request.qtyDesired);
      });

      return result;
    },
  },

  methods: {
    async createRequest(): Promise<void> {
      if (await DemandsV2Service.createRequest(this.demandV2) === true) {
        this.$emit('change');
      }
    },

    async editRequest(request: DemandRequest): Promise<void> {
      if (await DemandsV2Service.editRequest(request) === true) {
        this.$emit('change');
      }
    },

    /** Грид с :data сам не обновляется — по результату пункта меню перечитываем потребность */
    onContextMenuItemDone(item: unknown, row: DemandRequest, result: boolean | void): void {
      if (result === true) {
        this.$emit('change');
      }
    },
  },
});
</script>
